<template>
  <el-card class="box-card" v-loading="tableLoading">
    <!-- /* ---------------------------------- 表单查询 ---------------------------------- */ -->
    <el-row>
      <el-form v-bind="formProps.form" :rules="{}">
        <el-form-item :label="$t('wallet.label.createTime')">
          <range-date-picker ref="datePick" @showDateTime="handleShowTime" />
          <!--          <el-date-picker type="datetime" size="small" v-model="form.createTimeStart"-->
          <!--                          value-format="yyyy-MM-dd HH:mm:ss" />-->
          <!--          <span>~</span>-->
          <!--          <el-date-picker type="datetime" size="small" v-model="form.createTimeEnd"-->
          <!--                          value-format="yyyy-MM-dd HH:mm:ss" />-->
          <!--          <el-button-->
          <!--            size="mini"-->
          <!--            type="primary"-->
          <!--            v-for="(btn, key) in btnsTime"-->
          <!--            :key="key + Date.now()"-->
          <!--            @click="handleTime(key)"-->
          <!--            round>{{ btn }}-->
          <!--          </el-button>-->
        </el-form-item>
        <el-form-item prop="merchatNo" align="center" :label="$t('wallet.label.merchatNo')">
          <el-input v-model.trim="form.merchatNo" />
        </el-form-item>

        <el-form-item prop="systemOrderNo" align="center" :label="$t('momoLogs.systemOrderNo')">
          <el-input v-model.trim="form.systemOrderNo" />
        </el-form-item>
        <el-form-item prop="merchatOrderNo" align="center" :label="$t('momoLogs.merchantOrderNo')">
          <el-input v-model.trim="form.merchatOrderNo" />
        </el-form-item>
        <el-form-item
          prop="transactionType"
          align="center"
          :label="$t('wallet.label.transactionType')"
        >
          <el-select v-model="form.transactionType">
            <el-option
              v-for="item in types"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="channelName" align="center" :label="$t('wallet.label.channelName')">
          <el-select v-model="form.channelName">
            <el-option v-for="item in channelTypeList" :key="item" :value="item" />
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="updateAmount" align="center" :label="$t('wallet.label.updateAmount')">
          <el-input v-model.trim="form.updateAmount" />
        </el-form-item>

        <el-form-item prop="amount" align="center" :label="$t('wallet.label.amount')">
          <el-input v-model.trim="form.amount" />
        </el-form-item>
        <el-form-item prop="agentNo" align="center" :label="$t('wallet.label.agentNo')">
          <el-input v-model.trim="form.agentNo" />
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()"
            >{{ $t('btns.empty') }}
          </el-button>
          <el-button size="mini" type="primary" @click="handleSearch()"
            >{{ $t('btns.search') }}
          </el-button>

          <el-button
            size="mini"
            type="primary"
            v-if="tableList.length && permission.indexOf(`export:walletRecord`) > -1"
            @click="handleExport()"
          >
            {{ $t('btns.export') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- /* ---------------------------------- 表格展示 ---------------------------------- */ -->
    <el-row>
      <div class="header-table">
        <ul class="list-table">
          <li class="li-table" v-for="(item, index) in totalData" :key="index">
            <em class="label">
              <span v-for="(r, i) in types" :key="i" v-show="r.value === item.transactionType">
                {{ types[i] && types[i].label }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ item.amount | toThousands }}
            </span>
          </li>
        </ul>
      </div>

      <el-table
        :data="tableList"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
        stripe
      >
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          prop="merchantName"
          align="center"
          :label="$t('channelList.label.merchantName')"
        />
        <el-table-column
          prop="merchatNo"
          align="center"
          :label="$t('orders.label.table.merchatNo')"
        />
        <el-table-column
          prop="beforeAmount"
          align="center"
          :label="$t('wallet.label.beforeAmount')"
        >
          <template slot-scope="{ row }">
            {{ row.beforeAmount | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" align="center" :label="$t('wallet.label.amount')">
          <template slot-scope="{ row }">
            <span style="color: red" v-if="row.operate === 0">-</span>
            <span style="color: #409eff" v-else>+</span>
            <span>{{ row.amount | toThousands }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateAmount"
          align="center"
          :label="$t('wallet.label.updateAmount')"
        >
          <template slot-scope="{ row }">
            {{ row.updateAmount | toThousands }}
          </template>
        </el-table-column>
        <el-table-column
          prop="channelName"
          align="center"
          :label="$t('wallet.label.channelName')"
        />
        <el-table-column
          prop="channelType"
          align="center"
          :label="$t('wallet.label.channelType')"
        />
        <el-table-column prop="createTime" align="center" :label="$t('wallet.label.createTime')">
          <template slot-scope="{ row }">
            {{ row.createTime | asDayjs }}
          </template>
        </el-table-column>
        <el-table-column
          prop="merchatOrderNo"
          align="center"
          :label="$t('momoLogs.merchantOrderNo')"
        />
        <el-table-column
          prop="systemOrderNo"
          align="center"
          :label="$t('momoLogs.systemOrderNo')"
        />
        <el-table-column
          prop="transactionType"
          align="center"
          :label="$t('wallet.label.transactionType')"
        >
          <template slot-scope="{ row }">
            <template v-for="item in types">
              <el-tag :key="item.label" v-if="row.transactionType === item.value">
                {{ item.label }}
              </el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" :label="$t('withdraw.label.remark')">
        </el-table-column>
      </el-table>
    </el-row>

    <!-- /* ---------------------------------- 分页区域 ---------------------------------- */ -->
    <v-pagination v-model="pagination" :total="tableData.rows" @update="updateGetWalletList" />
  </el-card>
</template>

<script>
import wallet from '@/api/wallet';
import channelApi from '@/api/channel';
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment';
import RangeDatePicker from '../cuscom/range-date-picker.vue';


export default {
  name: 'walletRecord',
  components: {
    RangeDatePicker
  },
  data() {
    return {
      tableLoading: false,
      form: {
        channelName: '',
        createTimeStart: '',
        createTimeEnd: '',
        merchatNo: '',
        merchatOrderNo: '', //商户订单号
        transactionType: '',
        updateAmount: '',
        channelType: '',
        amount: '',
        agentNo: '',
        systemOrderNo: '' //系统订单号
      },
      pagination: {
        no: 1,
        size: this.$defaultPaginationSize
      },
      channelTypeData: {},
      tableData: {},
      totalData: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    tableList() {
      return this.tableData.list || [];
    },
    channelTypeList() {
      return (
        Object.keys(this.channelTypeData).filter((item) => {
          return ['bank_online', 'viettel_fix_qr'].indexOf(item) == -1;
        }) || []
      );
    },
    types() {
      return this.$t('wallet.types');
    },
    channelCodeList() {
      if (Array.isArray(this.channelTypeData[this.form.channelType])) {
        return this.channelTypeData[this.form.channelType].length > 0
          ? this.channelTypeData[this.form.channelType]
          : '';
      } else {
        return '';
      }
    },
    btnsTime() {
      return this.$t('orders.btns');
    },
    userType() {
      return this.$store.state.user.userType;
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.getWalletList();
    this.getTotal();
    this.getConfType();
    this.handleTime();
  },
  methods: {
    handleShowTime(val) {
      [this.form.createTimeStart, this.form.createTimeEnd] = val;
    },
    init() {
      this.handleSearch = debounce(() => {
        this.getWalletList(1);
        this.getTotal();
      }, 300);
      this.handleEmpty();
      this.formProps = {
        form: {
          ref: 'form',
          'label-width': 'auto',
          inline: true,
          size: 'small',
          rules: {}
        }
      };
    },
    /* ---------------------------------- 格式化数据 --------------------------------- */
    formatParams() {
      return {
        ...Object.keys(this.form).reduce((acc, key) => {
          if (this.form[key] === 0 || this.form[key]) {
            acc[key] = this.form[key];
          }
          return acc;
        }, {})
      };
    },

    /* ---------------------------------- 获取数据 ---------------------------------- */
    async getWalletList(number) {
      this.tableLoading = true;
      this.pagination.no = number;
      const { data } = await wallet.getPage({
        data: {
          query: {
            ...this.formatParams()
          },
          ...this.pagination
        }
      });
      if (data.code === 200) {
        this.tableData = data.data;
        this.tableLoading = false;
      } else {
        this.$message.error(data.msg);
        this.tableLoading = false;
      }
    },
    async updateGetWalletList(item) {
      const { data } = await wallet.getPage({
        data: { query: { ...this.formatParams() }, ...item }
      });
      if (data && data.code === 200) {
        this.tableData = data.data;
      } else {
        this.$message.error(data.msg);
      }
    },

    async getTotal() {
      const { data } = await wallet.getTotal(this.formatParams());
      if (data.code === 200) {
        this.totalData = data.data;
      } else {
        this.$message.error(data.msg);
      }
    },
    async getConfType() {
      const { data } = await channelApi.confType();
      if (data && data.code == 200) {
        this.channelTypeData = data.data;
        this.channelTypeData.all = '';
      }
    },

    /* --------------------------------- 事件驱动函数 --------------------------------- */
    handleEmpty() {
      this.form = {
        merchatNo: '',
        merchatOrderNo: '',
        transactionType: '',
        updateAmount: '',
        channelType: '',
        amount: '',
        agentNo: '',
        createTimeEnd: '',
        createTimeStart: '',
        systemOrderNo: ''
      };
      if (this.$refs.datePick) {
        this.$refs.datePick.handleTime();
      }
    },

    async handleExport() {
      const { data } = await wallet.doExport(this.formatParams());
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-Changes-funds-${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          this.$message.success(this.$t('status.success'));
        };
      } else {
        this.$message.error(data.msg);
      }
    },
    handleTime(type = '') {
      const date = new Date();
      // 当天零点
      const zeroTime = new Date(date.toLocaleDateString()).getTime();
      // 当年
      const nowY = date.getFullYear();
      // 当月
      const nowM = date.getMonth();
      // 当月第一天
      const firstDayNow = new Date(nowY, nowM, 1);
      // 上月第一天
      const firstDayNow1 = new Date(nowY, nowM - 1, 1);
      let start = '';
      let end = '';
      let tempDay = '';
      switch (type) {
        case 'today':
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'yesterday':
          if (this.form.createTimeStart) {
            tempDay = new Date(new Date(this.form.createTimeStart).toLocaleDateString()).getTime();
            start = this.timestamp(tempDay - 60 * 60 * 24 * 1000);
            end = this.timestamp(tempDay - 1);
          } else {
            start = this.timestamp(zeroTime - 60 * 60 * 24 * 1000);
            end = this.timestamp(new Date(new Date().toLocaleDateString()).getTime() - 1);
          }
          break;
        case 'month':
          start = this.timestamp(firstDayNow);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case 'lastMonth':
          start = this.timestamp(firstDayNow1);
          end = this.timestamp(new Date(firstDayNow).getTime() - 1);
          break;
        default:
          break;
      }
      this.form.createTimeStart = start;
      this.form.createTimeEnd = end;
    },
    timestamp(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
  }
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  padding-right: 40px;
}

.header-table .list-table {
  display: flex;
  list-style: none;
}

.header-table .list-table li {
  display: flex;
  list-style: none;
}

.header-table .list-table li .label {
  font-style: normal;
}

.header-table .list-table li .value {
  display: flex;
  list-style: none;
}

.header-table .list-table li:nth-child(n + 2) {
  margin-left: 30px;
}

.header-table .btn-table {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/walletRecord/index.vue